import React from "react";
import * as legalModule from "@/data/legalContent";

function BodyRenderer({ text }) {
  if (!text) return null;
  // Split on blank lines into paragraphs, preserve inline newlines
  const paragraphs = String(text).split(/\n\s*\n/);
  return (
    <div className="space-y-3">
      {paragraphs.map((p, i) => (
        <p key={i} className="text-sm whitespace-pre-line" style={{ color: "var(--pa-text-primary)" }}>{p}</p>
      ))}
    </div>
  );
}

export default function Legal() {
  const docs = legalModule.LEGAL_DOCS || [];
  const updated = legalModule.LEGAL_LAST_UPDATED;
  const contact = legalModule.LEGAL_CONTACT_EMAIL;

  return (
    <div className="space-y-6">
      <header>
        <h1 className="pa-serif text-3xl md:text-4xl" style={{ color: "var(--pa-text-primary)" }}>Legal</h1>
        {updated && <p className="text-xs mt-1" style={{ color: "var(--pa-text-muted)" }}>Updated {updated}</p>}
      </header>
      {docs.map((d) => (
        <section key={d.key} className="pa-card p-5 md:p-6">
          <h2 className="pa-serif text-xl mb-3" style={{ color: "var(--pa-gold)" }}>{d.title}</h2>
          <BodyRenderer text={d.body} />
          {(d.sections || []).map((s, j) => (
            <div key={j} className="mt-4">
              {s.heading && <h3 className="pa-serif text-base mb-2" style={{ color: "var(--pa-text-primary)" }}>{s.heading}</h3>}
              {s.body && <BodyRenderer text={s.body} />}
              {s.bullets && (
                <ul className="text-sm list-disc list-inside mt-2" style={{ color: "var(--pa-text-secondary)" }}>
                  {s.bullets.map((b, k) => <li key={k}>{b}</li>)}
                </ul>
              )}
            </div>
          ))}
        </section>
      ))}
      {contact && (
        <p className="text-xs text-center" style={{ color: "var(--pa-text-muted)" }}>
          Contact: <a href={`mailto:${contact}`} style={{ color: "var(--pa-gold)" }}>{contact}</a>
        </p>
      )}
    </div>
  );
}
